import axios from "axios";
import { API_KEY, API_URL } from "../constants/config";

const DEFAULT_CMS_URL = "https://localhost:1337"

export const cms = axios.create({
  baseURL: `${API_URL ?? DEFAULT_CMS_URL}/api`,
  headers: {
    Authorization: `Bearer ${API_KEY ?? ""}`,
  },
});
